import React from 'react';
import { Quote, Cloud, Landmark, Ship } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Jonas Gamboa',
      role: 'IT Director',
      industry: 'Global Technology & Cloud Infrastructure',
      icon: Cloud,
      text: 'Very supportive team from end to finish of your request. Fair price! The team will give the best suggestions based on your requests.',
    },
    {
      name: 'Sarah Al-Rashid',
      role: 'Sustainability Manager',
      industry: 'Banking & Financial Services',
      icon: Landmark,
      text: 'Grenew has transformed our e-waste management process. Their certified services give us complete peace of mind regarding data security and compliance.',
    },
    {
      name: 'Ahmed Hassan',
      role: 'Operations Head',
      industry: 'Global Logistics & Supply Chain',
      icon: Ship,
      text: 'Professional, reliable, and truly committed to sustainability. We have been partnering with Grenew for over 3 years with excellent results.',
    }
  ];

  return (
    <section className="py-20 lg:py-24 bg-[#0a1628]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-light text-white">
            What Our <span className="font-semibold">Clients Say</span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, i) => (
            <div 
              key={i} 
              className="bg-white/5 p-8 border border-white/10 hover:border-[#4fd1c5]/30 transition-all duration-500 ease-out"
            >
              <Quote className="w-10 h-10 text-[#4fd1c5] mb-6" />
              <p className="text-gray-300 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#4fd1c5]/20 rounded-full flex items-center justify-center">
                  <span className="text-[#4fd1c5] font-semibold">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-white font-semibold">{testimonial.name}</p>
                  <p className="text-gray-400 text-sm">{testimonial.role}</p>
                  <p className="text-[#4fd1c5] text-xs font-medium flex items-center gap-1 mt-1">
                    <testimonial.icon className="w-3 h-3" />
                    {testimonial.industry}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
